import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-1",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground border-current",
        // Celebration type badges
        birthday: "border-transparent bg-pink-100 text-pink-700",
        wedding: "border-transparent bg-rose-100 text-rose-700",
        anniversary: "border-transparent bg-purple-100 text-purple-700",
        corporate: "border-transparent bg-blue-100 text-blue-700",
        general: "border-transparent bg-teal-100 text-teal-700",
        // Status badges
        draft: "border-transparent bg-gray-100 text-gray-600",
        active: "border-transparent bg-green-100 text-green-700",
        completed: "border-transparent bg-blue-100 text-blue-700",
        cancelled: "border-transparent bg-red-100 text-red-600",
        // RSVP badges
        accepted: "border-transparent bg-green-100 text-green-700",
        declined: "border-transparent bg-red-100 text-red-600",
        invited: "border-transparent bg-amber-100 text-amber-700",
        pending: "border-transparent bg-amber-100 text-amber-700",
        new: "border-transparent bg-blue-100 text-blue-700",
        // Fun gradient
        fun: "border-transparent bg-gradient-to-r from-pink-100 to-purple-100 text-purple-700",
      },
      size: {
        default: "px-2 py-0.5 text-xs",
        sm: "px-1.5 py-0 text-[10px]",
        lg: "px-2.5 py-1 text-xs",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, size }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
